var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wizard",
        {
          ref: "formWiz",
          staticClass: "mb-3",
          attrs: {
            color: "#B1D06C",
            title: null,
            subtitle: null,
            shape: "square",
            "finish-button-text": "Submit",
            "back-button-text": "Previous",
          },
          on: { "on-complete": _vm.formSubmitted },
        },
        [
          _c(
            "tab-content",
            { attrs: { title: "Chosen Customer" } },
            [
              _c("SelectCustomer", {
                attrs: { leadClientId: _vm.serviceOne.leadClientId },
              }),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "Chosen Service" } },
            [
              _c("SelectTemplate", {
                attrs: { serviceId: _vm.serviceOne.itemId },
              }),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "Modify your template" } },
            [
              _c(
                "b-container",
                { staticClass: "text-center" },
                [
                  _c("TemplateView", {
                    attrs: { templateId: _vm.serviceOne },
                    on: { onchange: _vm.template },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "Modify Price & Submit" } },
            [
              _c("Price", {
                attrs: { product: _vm.serviceOne },
                on: { price: _vm.price },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }